import store from './rootStore';

export default store;
